export default __webpack_public_path__ + "static/media/reims8.c375be64.jpg";